import { Component, Input, OnInit } from '@angular/core';
import { Ad } from 'src/app/models/ad';
import { MatDialog } from '@angular/material/dialog';
import { AdComponent } from '../../company-stand/ad/ad.component';

@Component({
  selector: 'app-ad-card',
  templateUrl: './ad-card.component.html',
  styleUrls: ['./ad-card.component.scss']
})
export class AdCardComponent implements OnInit {

  @Input()
  public ad: Ad;

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  openAd(): void {
    this.dialog.open(AdComponent, {
      data: {
        image: this.ad.logoUrl,
        title: this.ad.adTitle,
        description: this.ad.description
      },
      autoFocus: false
    });
  }
}
